<template>
  <div class="contact">
    <div class="section-background">
      <div class="container">
        <div class="wrapper">
          <div>
            <h1>Resource not found</h1>
          </div>
          <div>
            OOOPS, Requested page could not be found...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Error`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 600px;
}
</style>
